import { memo } from "react";
import { useTranslation } from "react-i18next";

const ICON_SIZE = 11;

const SparkleIcon = () => (
  <svg width={ICON_SIZE} height={ICON_SIZE} viewBox="0 0 24 24" aria-hidden>
    <path fill="currentColor" d="M10 5Q11 13 19 14Q11 15 10 23Q9 15 1 14Q9 13 10 5Z" />
    <path stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" d="M19 1v6M16 4h6" />
    <circle fill="currentColor" cx="3" cy="21.5" r="1.8" />
  </svg>
);

const AskDatatramBadge = () => {
  const { t } = useTranslation();

  return (
    <span className="audience-overview__ai-badge">
      <SparkleIcon />
      {t("audienceOverview.askDatatramAi")}
    </span>
  );
};

export default memo(AskDatatramBadge);
